import { render } from "./PromiseIcon2.vue?vue&type=template&id=c4743ba0"
import script from "./PromiseIcon2.vue?vue&type=script&lang=js"
export * from "./PromiseIcon2.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__